<template>
  <div class="enter_form">
    <p class="tip">当前手机号还不是销巴会员，请先注册销巴会员</p>
    <el-form label-position="top">
      <el-form-item label="手机号">
        <el-input v-model="registObj.phone" placeholder="请输入您的手机号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码">
        <el-input v-model="registObj.pwd" placeholder="密码6-32位，由数字、字母、特殊字符至少两种组合"></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="registObj.pwdagain" placeholder="请再次输入密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="registObj.checked"></el-checkbox>
        <span class="checkbox-label">
          阅读并接受
          <a @click="getProtocol(1)">《销巴生活用户服务协议》</a>
          及
          <a @click="getProtocol(2)">《隐私协议》</a>
        </span>
      </el-form-item>
    </el-form>
    <el-row class="btn-submit">
      <el-button @click="next" type="danger" :disabled="!registObj.checked">下一步，选择店铺类型</el-button>
    </el-row>

    <!-- 协议 -->
    <el-dialog :visible.sync="dialogVisible" width="500px">
      <div class="header">
        <p class="date">
          更新时间
          2017.06.29
        </p>
        <p class="title">销巴生活用户服务协议</p>
      </div>
      <div class="line"></div>
      <div class="body">
        具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力具有良好的销售和团队管理理念三年以上销售工作经验，
        一年以上销售经理经验工作责任心强，能承受较大的工作压力
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: "form"
  },
  props: {
    form: Object
  },
  data() {
    return {
      registObj: {},
      dialogVisible: false,
      verifyStatus: false,
      verifyText: "获取验证码"
    };
  },
  methods: {
    next() {
      console.log(this.registObj);

      this.form.step = 1;
      this.$emit("update:form", this.form);
    },
    // 获取协议
    getProtocol(type) {
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.enter_form {
  width: 417px;

  .tip {
    margin-bottom: 20px;
    color: #555555;
    font-size: 24px;
  }

  // 协议多选框
  /deep/ .el-checkbox {
    margin-right: 8px;

    .el-checkbox__inner {
      border-color: #dcdfe6;
    }

    &.is-checked .el-checkbox__inner {
      border-color: #e60616;
      background-color: #fff;
    }

    &__inner:hover,
    &__inner::after {
      border-color: #e60616;
    }
  }
  .checkbox-label {
    color: #999;

    a {
      color: #e60616;
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .btn-submit {
    .el-button--danger:not([disabled]) {
      background-color: #e60616;
    }
  }

  // 协议弹出框
  /deep/ .el-dialog {
    &__header,
    &__body {
      padding: 0;
    }
    &__close {
      font-size: 27px;
    }
    .header {
      padding: 25px 40px 10px;
      .date {
        color: #999999;
        font-size: 15px;
        margin-bottom: 8px;
      }
      .title {
        color: #333333;
        font-size: 30px;
      }
    }
    .line {
      height: 1px;
      background: rgba(238, 238, 238, 1);
    }
    .body {
      padding: 20px 40px;
    }
  }
}
</style>